import { StableSeverityColors } from '@twaice-fe/frontend/shared/utilities';
import { alertIconConfig } from '../../../component-sidebar.config';
import { AlertSeverity } from '../../../component-sidebar.types';
import { FilterOptions, UiRuleState } from './component-rule-transitions.types';

const toBreachState = (severity: AlertSeverity, stateLabel: string): UiRuleState => {
  const { iconName, tagBackgroundColor, tagBorderColor, tagTextColor, tagIconColor } = alertIconConfig[severity];
  return {
    backgroundColor: tagBackgroundColor,
    borderColor: tagBorderColor,
    stateLabel,
    stateIcon: iconName,
    stateIconColor: tagIconColor,
    textColor: tagTextColor,
  };
};

export const stateMap: Record<AlertSeverity, UiRuleState> = {
  [AlertSeverity.Normal]: {
    backgroundColor: StableSeverityColors.background,
    borderColor: StableSeverityColors.border,
    stateLabel: 'Normal',
    stateIcon: 'circle-check',
    stateIconColor: StableSeverityColors.text,
    textColor: StableSeverityColors.text,
  },
  [AlertSeverity.Minor]: toBreachState(AlertSeverity.Minor, 'Minor'),
  [AlertSeverity.Medium]: toBreachState(AlertSeverity.Medium, 'Moderate'),
  [AlertSeverity.High]: toBreachState(AlertSeverity.High, 'Critical'),
};

export const isShownUnderFilter = (selectedFilter: FilterOptions, itemFilter: FilterOptions): boolean =>
  selectedFilter === FilterOptions.ALL || selectedFilter === itemFilter;
